import SidebarToggleIcon from '@components/v2/icons/SidebarToggle';
import {
  ContextMode,
  PeekPointerHandlers,
} from '@components/v2/layout/AppTemplate/appTemplate.types';
import IconButton from '@components/v2/ui/IconButton/IconButton';
import { AppBar, Box, Toolbar } from '@mui/material';
import { ArrowLeft } from 'lucide-react';
import { type ReactNode } from 'react';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../modules/translation/TranslationContext';
import { AppTemplateTestIds } from '../../../../../../utils/testIds/appTemplate.testIds';
import { useHeaderStyles } from './header.styles';

interface HeaderProps {
  contextMode?: ContextMode;
  isMobile?: boolean;
  isMenuExpanded?: boolean;
  showMenuToggle?: boolean;
  menuTogglePeek?: PeekPointerHandlers;
  onMenuToggle: () => void;
  children?: ReactNode;
}

const Header = ({
  contextMode = 'root',
  isMobile = false,
  isMenuExpanded,
  showMenuToggle = true,
  menuTogglePeek,
  onMenuToggle,
  children,
}: HeaderProps) => {
  const { classes } = useHeaderStyles();
  const { translate } = useTranslation();
  const isBackButton = contextMode === 'nested' && !isMobile;

  return (
    <AppBar className={classes.appBar} color="transparent" elevation={0} position="static">
      <Toolbar className={classes.toolbar} disableGutters>
        {showMenuToggle && (
          <Box
            className={classes.menuToggleSlot}
            onPointerEnter={menuTogglePeek?.onPointerEnter}
            onPointerLeave={menuTogglePeek?.onPointerLeave}
          >
            <IconButton
              className={classes.shellIconButton}
              icon={isBackButton ? ArrowLeft : SidebarToggleIcon}
              size="medium"
              testId={AppTemplateTestIds.MENU_TOGGLE_BUTTON}
              ariaLabel={translate(isBackButton ? LangEnum.GLOBAL_BACK : LangEnum.GLOBAL_MENU)}
              ariaExpanded={isBackButton ? undefined : isMenuExpanded}
              onClick={onMenuToggle}
            />
          </Box>
        )}
        {children}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
